//############################################################################################
//# axboot.file
//############################################################################################

axboot.file = function () {
    var download = function (url, data, callback) {
        $.fileDownload(url, {
            httpMethod: 'GET',
            data: data,
            prepareCallback: function (url) {
                axAJAXMask.open();
            },
            abortCallback: function (url) {
                axAJAXMask.close(300);
            },
            successCallback: function (url) {
                axAJAXMask.close(300);

                if (!ax5.util.isNothing(callback) && ax5.util.getType(callback) === 'function') {
                    callback.call(this);
                }
            },
            failCallback: function (responseHtml, url, error) {
                axDialog.alert('File download failed!');
                axAJAXMask.close(300);
            }
        });
    }

    return {
        'download' : download
    }
}();
